import script from "./PromotionalBannersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionalBannersComponent.vue?vue&type=script&setup=true&lang=js"

import "./PromotionalBannersComponent.vue?vue&type=style&index=0&id=1e872d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e872d04"]])

export default __exports__